import { useReactiveVar } from '@apollo/client';

export const useReactiveState = (reactiveVar) => {
  const value = useReactiveVar(reactiveVar);

  return [value, reactiveVar];
};
